export const SURVEY_IMAGE_VIEWER_GUIDE_FILENAME =
  'Survey Image Viewer_ How to Use-230626-132731.pdf' as const;

export const SURVEY_IMAGE_VIEWER_GUIDE_PATH =
  `/docs/${SURVEY_IMAGE_VIEWER_GUIDE_FILENAME}` as const;

/** URL-safe path for opening the guide PDF in a new tab. */
export function surveyImageViewerGuideUrl(): string {
  return encodeURI(SURVEY_IMAGE_VIEWER_GUIDE_PATH);
}
